// Basic
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// Components
import Icon from '@/common-utils/components/renders/icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import NETWORK_INTERFACE_TYPE from '@/app/modules/terminals/enums/NetworkInterfaceType';
import ICONS from '@/common-utils/enums/icons';
import CUSTOM_PAY_SIM_OFFERS_PROVIDERS from '../../enums/CustomPaySimOffersProviders';
import SIM_OFFERS_PROVIDERS from '../../enums/SimOffersProviders';

/**
 * @param root0
 * @param root0.iccidOperators
 * @param root0.showDefaultOperatorMessage
 * @param root0.className
 * @returns {JSX} RenderSimOperator
 */
function RenderSimOperator({ iccidOperators, showDefaultOperatorMessage = true, className = '' }) {

    // Translation -- CHANGE FOR SIM WHEN SIMS WILL BE DONE
    const { t: translate } = useTranslation('terminal');

    // Constants
    const defaultMessage = showDefaultOperatorMessage ? translate(NETWORK_INTERFACE_TYPE.OTHER.entity) : null;
    const operators = (iccidOperators || []).map((value) => {
        const providers = { ...SIM_OFFERS_PROVIDERS, ...CUSTOM_PAY_SIM_OFFERS_PROVIDERS };
        for (const provider of Object.values(providers)) {
            if (value === provider.name || value === provider.key) {
                return provider.name;
            }
        }
        return value;
    });
    const oneOrLessOperator = operators && operators.length === 1 ? operators : defaultMessage;

    return (
        <div className={iccidOperators?.length > 0 ? className : ''}>
            {
                iccidOperators?.length > 1 ?
                    <div className='tipOperator'>
                        <TooltipHelper
                            trigger={<Icon icon={ICONS.UNKNOWN} />}
                            content={
                                <ul className='tipOperatorList'>
                                    <li>{translate('sim.operator')}</li>
                                    {iccidOperators.map((element) =>
                                        <li key={element}>{element}</li>
                                    )}
                                </ul>
                            }
                        />
                    </div>
                    :
                    oneOrLessOperator && (
                        <div className='ellipsis' title={oneOrLessOperator}>
                            {oneOrLessOperator}
                        </div>
                    )
            }
        </div>
    );

}
RenderSimOperator.propTypes = {
    iccidOperators: PropTypes.arrayOf(PropTypes.string),
    showDefaultOperatorMessage: PropTypes.bool,
    className: PropTypes.string
};

export default RenderSimOperator;